import { styled } from '@fv/design-tokens'

export const SubNavigation = styled.div``
